import { render, staticRenderFns } from "./M_logoConfigure.vue?vue&type=template&id=40451499&scoped=true&"
import script from "./M_logoConfigure.vue?vue&type=script&lang=js&"
export * from "./M_logoConfigure.vue?vue&type=script&lang=js&"
import style0 from "./M_logoConfigure.vue?vue&type=style&index=0&id=40451499&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40451499",
  null
  
)

export default component.exports